const SITE_URL = 'https://nmhelper.in/';
const OG_IMAGE = 'https://nmhelper.in/thumbnail.jpg';
const PLAY_STORE =
  'https://play.google.com/store/apps/details?id=in.nmhelper.app';

const FEATURE_LIST_EN = [
  'Daily NM present for MDMS with boys and girls per class',
  'MDMS nutrition counts for egg, banana, and milk when served',
  'Head dashboard with NM and nutrition reports and history',
  'Offline save with automatic sync when data returns',
  'English and Malayalam interface',
  'CSV, ODS, and document export',
];

const FEATURE_LIST_ML = [
  'MDMS NM ഹാജർ: ക്ലാസിന് ആൺ, പെൺ',
  'മുട്ട, വാഴപ്പഴം, പാൽ പോഷകാഹാര എണ്ണം (MDMS)',
  'ഹെഡ് റിപ്പോർട്ട്, ചരിത്രം, എക്സ്പോർട്ട്',
  'ഓഫ്‌ലൈൻ സേവ്, പിന്നീട് സിങ്ക്',
  'ഇംഗ്ലീഷ്, മലയാളം',
  'CSV, ODS, DOC എക്സ്പോർട്ട്',
];

export function buildSeoGraph({ labels, lang, faqs = [], pageUrl = SITE_URL }) {
  const desc =
    labels.landingMetaDescription ||
    labels.landingSubtitle ||
    labels.landingFooterTagline ||
    '';

  const titleStr = `${labels.landingTitle} | NMhelper`;
  const featureList = lang === 'ml' ? FEATURE_LIST_ML : FEATURE_LIST_EN;

  const faqEntities = faqs
    .filter((f) => f && f.q && f.a)
    .map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    }));

  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        '@id': SITE_URL + '#website',
        url: SITE_URL,
        name: 'NMhelper',
        description: desc,
        inLanguage: [lang, lang === 'ml' ? 'en' : 'ml'],
        publisher: { '@id': SITE_URL + '#organization' },
      },
      {
        '@type': 'Organization',
        '@id': SITE_URL + '#organization',
        name: 'NMhelper',
        url: SITE_URL,
        logo: 'https://nmhelper.in/logo512.png',
        image: OG_IMAGE,
        email: 'nishalamv@gmail.com',
        areaServed: {
          '@type': 'State',
          name: 'Kerala',
          containedInPlace: { '@type': 'Country', name: 'India' },
        },
      },
      {
        '@type': 'WebPage',
        '@id': pageUrl + '#webpage',
        url: pageUrl,
        name: titleStr,
        description: desc,
        inLanguage: lang,
        isPartOf: { '@id': SITE_URL + '#website' },
        about: { '@id': SITE_URL + '#software' },
        primaryImageOfPage: { '@type': 'ImageObject', url: OG_IMAGE },
      },
      {
        '@type': 'SoftwareApplication',
        '@id': SITE_URL + '#software',
        name: 'NMhelper',
        applicationCategory: 'EducationalApplication',
        operatingSystem: 'Android, Web',
        url: SITE_URL,
        downloadUrl: PLAY_STORE,
        screenshot: OG_IMAGE,
        description: desc,
        featureList,
        inLanguage: ['en', 'ml'],
        offers: {
          '@type': 'Offer',
          price: '0',
          priceCurrency: 'INR',
          description: 'Free download; schools pay per class after trial',
        },
        areaServed: {
          '@type': 'State',
          name: 'Kerala',
          containedInPlace: { '@type': 'Country', name: 'India' },
        },
        audience: {
          '@type': 'EducationalAudience',
          educationalRole: ['head teacher', 'teacher'],
          geographicArea: { '@type': 'State', name: 'Kerala' },
        },
      },
      ...(faqEntities.length
        ? [{ '@type': 'FAQPage', '@id': pageUrl + '#faq', inLanguage: lang, mainEntity: faqEntities }]
        : []),
    ],
  };
}
